import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import BookIcon from '@material-ui/icons/Book';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import { Framework } from '@flint/framework';
import { authProvider } from "../../../common/authProvider";

import vetLogo from "../../../assets/blueLogo.png";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(4),

    },
    paper: {
        width: '100%',
        height: "100%",
    },
    card: {
        height: "100%",
    },
    cardIcon: {
        width: "100%",
        height: "auto",
        maxHeight: "120px",
        marginBottom: theme.spacing(1),
    },
    cardActions: {
        justifyContent: "space-between",
        alignItems: "stretch",
    },
    cardButton: {
        width: "100%",
        color: "#FFF",
        padding: "8px",
        fontSize: "14px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "uppercase",
        transition: "background 0.25s",
        border: "2px solid #222747",
        "&:hover": {
            background: "none",
            color: "#222747",
        },
    },
    orangeButton: {
        background: "#DD7153",
        border: "2px solid #DD7153",
        "&:hover": {
            background: "none",
            color: "#DD7153",
        },
    },
    cardContent: {
        color: "#222747",
    },
    cardImg: {
        height: "170px",
        backgroundSize: "contain",
        backgroundPosition: "center",
    },
}));

const Dashboard = () => {
    const classes = useStyles();
    const redirectVetFront = () => {
        window.open(process.env.REACT_APP_FRONTEND_URL + '/api/admin-login/' + authProvider.account.userName);
    }
    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                    <Paper className={classes.paper}>
                        <Card className={`${classes.root} ${classes.card}`}>
                            <CardContent className={classes.cardContent}>
                                <MenuBookIcon className={classes.cardIcon} />
                                <Typography gutterBottom variant="h5" component="h2" align="center">ePub Management</Typography>
                            </CardContent>
                            <CardActions className={classes.cardActions}>
                                <Button size="small" variant="contained" className={classes.cardButton}
                                    onClick={() => Framework.redirect(`/epubs`)}>View all ePubs</Button>
                                <Button size="small" variant="contained" className={classes.cardButton}
                                    onClick={() => Framework.redirect(`/add-epub`)}>Upload new ePub</Button>
                            </CardActions>
                        </Card>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Paper className={classes.paper}>
                        <Card className={`${classes.root} ${classes.card}`}>
                            <CardContent className={classes.cardContent}>
                                <LibraryBooksIcon className={classes.cardIcon} />
                                <Typography gutterBottom variant="h5" component="h2" align="center">Topic Management</Typography>
                            </CardContent>
                            <CardActions className={classes.cardActions}>
                                <Button size="small" variant="contained" className={classes.cardButton}
                                    onClick={() => Framework.redirect(`/upload-csv`)}>Upload new CSV</Button>
                                <Button size="small" variant="contained" className={classes.cardButton}
                                    onClick={() => Framework.redirect(`/add-genus-specialty`)}>Add Genus Specialty</Button>
                            </CardActions>
                        </Card>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Paper className={classes.paper}>
                        <Card className={`${classes.root} ${classes.card}`}>
                            <CardContent className={classes.cardContent}>
                                <BookIcon className={classes.cardIcon} />
                                <Typography gutterBottom variant="h5" component="h2" align="center">Product Management</Typography>
                            </CardContent>
                            <CardActions className={classes.cardActions}>
                                <Button size="small" variant="contained" className={classes.cardButton}
                                    onClick={() => Framework.redirect(`/subscriptions`)}>View all Products</Button>
                                <Button size="small" variant="contained" className={classes.cardButton}
                                    onClick={() => Framework.redirect(`/add-subscription`)}>Create Product</Button>
                            </CardActions>
                        </Card>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Paper className={classes.paper}>
                        <Card className={`${classes.root} ${classes.card}`}>
                            <CardContent className={classes.cardContent}>
                                <PeopleAltIcon className={classes.cardIcon} />
                                <Typography gutterBottom variant="h5" component="h2" align="center">User Management</Typography>
                            </CardContent>
                            <CardActions className={classes.cardActions}>
                                <Button size="small" variant="contained" className={classes.cardButton}
                                    onClick={() => Framework.redirect(`/users`)}>View all Users</Button>
                            </CardActions>
                        </Card>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Paper className={classes.paper}>
                        <Card className={`${classes.root} ${classes.card}`}>
                            <CardMedia
                                className={classes.cardImg}
                                image={vetLogo}
                                title="Contemplative Reptile"
                            />
                            <CardContent className={classes.cardContent}>
                                {/* <Typography gutterBottom variant="h5" component="h2" align="center">VetConsult</Typography> */}
                            </CardContent>
                            <CardActions className={classes.cardActions}>
                                <Button size="small" variant="contained" onClick={redirectVetFront} className={`${classes.cardButton} ${classes.orangeButton}`}>Go to VetConsult</Button>
                            </CardActions>
                        </Card>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

export default Dashboard;